
import React from 'react';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';

import './cards.css';
import iconArrowTotales from '../img/iconArrowTotales.svg';
import { Box, CircularProgress, Typography } from '@mui/material';
import { checkValidNumber } from '../../../helpers/general';

export const CardGastoP = ({ setOpenTotales }) => {

    const { access } = useSelector(state => state.auth)
    const { total_gasto_p, margen_gasto_p, separacion_miles, separacion_decimales, simbolo } = useSelector(state => state.ppto.detail);

    return access.a20 ? (
        <div className='cards-totales-ppto bg-gp'>
            <CircularProgressWithLabel value={margen_gasto_p ? margen_gasto_p.toFixed(2) : 0} />
            <div className='text-center'>
                <NumberFormat
                    className='items-prices'
                    value={total_gasto_p || 0}
                    displayType={'text'}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    prefix={`${simbolo} `}
                    decimalScale={2}
                    fixedDecimalScale
                />
                <span style={{ fontSize: '13px' }}>Total costos netos</span>
            </div>
            <img
                style={{ cursor: 'pointer' }}
                src={iconArrowTotales}
                alt="icon"
                onClick={() => setOpenTotales(true)}
            />
        </div>
    ) : <div className='cards-totales-ppto-hide'></div>
}

const CircularProgressWithLabel = ({ value }) => {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" value={-value} size='60px' style={{ color: '#FF4A4A' }} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant="caption" component="div" color="text.secondary" style={{ padding: '20px', color: '#919191' }}>
                   {/*  {`${Math.round(checkValidNumber(value))}%`} */}
                    {`${checkValidNumber(value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}